import React, { useEffect, useState } from 'react';
import HomeThreeMain from './HomeThreeMain';
import FooterStyleThree from '../../components/Layout/Footer/FooterStyleThree';
import HeaderStyleThree from '../../components/Layout/Header/HeaderStyleThree';
import BackToTop from '../../components/elements/BackToTop';

const HomeThree = () => {
	const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

	return (
		<div className="homestyle2">
		<React.Fragment>
			
            <HeaderStyleThree />
            <HomeThreeMain/>
            <BackToTop scroll={isVisible} />
            <FooterStyleThree />
		</React.Fragment>
		</div>
	);
}

export default HomeThree;
